import { ofType } from "redux-observable";
import { map, retry, switchMap } from "rxjs/operators";
import { CommandCode, } from "../../../utils/network/generated/protoTypes";
import { actionCoopInfoInvitePlayerResponse, TypeActionCoopInfo, } from "../actionCoop";
export var epicCoopInvitePlayer = function (action$, state$, deps) {
    return action$.pipe(ofType(TypeActionCoopInfo.InvitePlayer), switchMap(function (action) {
        var playerId = action.playerId, coopId = action.coopId, playerIdToInvite = action.playerIdToInvite;
        return deps.netSend({
            id: CommandCode.CoopInvitePlayer,
            props: {
                coopId: coopId,
                playerId: playerId,
                playerIdToInvite: playerIdToInvite,
            },
        });
    }), retry(), map(actionCoopInfoInvitePlayerResponse));
};



//////////////////
// WEBPACK FOOTER
// ./src/features/cooperative/epic/epicCoopInvitePlayer.ts
// module id = 1807
// module chunks = 3